import { addCampaign } from "@/business/campaign/application/addCampaign";
import { deleteCampaign } from "@/business/campaign/application/deleteCampaign";
import { editCampaign } from "@/business/campaign/application/editCampaign";
import { getAllCampaigns } from "@/business/campaign/application/getAllCampaigns";
import { Campaign } from "@/business/campaign/domain/campaign";
import { ref, Ref, onMounted } from "vue";
import { deleteAdditionalImage } from "@/business/campaign/application/deleteAdditionalImage";

export function campaignsUse() {
  const modalInfoCampaign: Ref<boolean> = ref(false);
  const modalConfirmation: Ref<boolean> = ref(false);
  const campaigns: Ref<Campaign[]> = ref([]);
  const selectedCampaign: Ref<Campaign | null> = ref(null);

  onMounted(async () => {
    campaigns.value = await getAllCampaigns.execute();
  });

  function closeInformationCampaignModal() {
    modalInfoCampaign.value = false;
    selectedCampaign.value = null;
  }

  function manageConfirmationModal(value: boolean) {
    modalConfirmation.value = value;
  }

  function closeConfirmationModal() {
    modalConfirmation.value = false;
    selectedCampaign.value = null;
  }

  async function createCampaignOperation(
    campaignName: string,
    icon: File,
    image1: File | null,
    image2: File | null
  ) {
    await addCampaign.execute(campaignName, icon, image1, image2);
    await refreshCampaigns();
    selectedCampaign.value = campaigns.value[0];
  }

  async function editCampaignOperation(
    campaignName: string,
    icon: File | null,
    image1: File | null,
    image2: File | null
  ) {
    await editCampaign.execute(
      selectedCampaign.value?.campaignName ?? "",
      icon,
      image1,
      image2
    );
    await refreshCampaigns();
    selectedCampaign.value = null;
  }

  async function deleteCampaignOperation() {
    await deleteCampaign.execute(selectedCampaign.value?.campaignName ?? "");
    await refreshCampaigns();
  }

  async function deleteAdditionalImageCampaignOperation(position: number) {
    await deleteAdditionalImage.execute(
      selectedCampaign.value?.campaignName ?? "",
      position
    );
    await refreshCampaigns();
    selectedCampaign.value =
      campaigns.value.find(
        (campaign) =>
          campaign.campaignName == selectedCampaign.value?.campaignName
      ) ?? null;
  }

  async function refreshCampaigns() {
    campaigns.value = await getAllCampaigns.execute();
  }

  function createNewCampaign() {
    selectedCampaign.value = null;
    modalInfoCampaign.value = true;
  }

  function editCampaignSelected(campaign: Campaign) {
    selectedCampaign.value = campaign;
    modalInfoCampaign.value = true;
  }

  return {
    modalInfoCampaign,
    closeInformationCampaignModal,
    modalConfirmation,
    manageConfirmationModal,
    closeConfirmationModal,
    createCampaignOperation,
    editCampaignOperation,
    deleteCampaignOperation,
    selectedCampaign,
    createNewCampaign,
    editCampaignSelected,
    campaigns,
    deleteAdditionalImageCampaignOperation,
  };
}
